import { EntityMetadata } from "@/models/EntityMetadata";

export class RequestSalvaDatiAggiuntiviLavorazione
{
    public idLavorazione?: string;

    public datiAggiuntivi?: EntityMetadata[];    
}